<template>
    <draggable style="width:100%" class="draggable-container" :options="{ animation: 350, group:'elements', handle: '.draggable-handle'}" @end="afterDrag">
    <div v-if="!items || items.length < 1" style="display:flex">
        <div>
            <v-icon color="grey lighten-2">mdi-comment-outline</v-icon>
        </div>
        <div class="grey--text text--lighten-1 pl-2">No Data</div>
    </div>
    <div v-for="item in items"
        :title="item.order"
        @click.stop
        @click.exact="unselectAll()"
        @click.meta="selectMulti(item)" 
        @click.ctrl="selectMulti(item)"
        @click.shift="selectRange(item)" 
        :data-order="item.order" :data-id="item._id" 
        style="display:inline-block"
        :style="itemStyle" 
        :key="item._id" class="draggable-item" :class="{selected: item._selected}">
        <div style="display:flex">

            <div style="flex-basis:99%;max-width:99%">
                <slot v-bind:item="item">
                    <ObjectViewer :item="item" />
                </slot>
            </div>
            <div class="pt-1" @click.stop style="margin-left:-3px;margin-right:-3px">
                <v-menu left offset-y>
                    <template v-slot:activator="{ on }">
                        <v-icon style="margin-top:-1px;" class="draggable-handle clickable" v-on="on">more_vert</v-icon>
                    </template>
                    <v-list>
                        <slot name="menu" :item="item" :selectedItems="selectedItems">
                            <!-- <v-list-item v-for="n in 3" :key="n">
                                <v-list-item-title>No Menu Passed</v-list-item-title>
                            </v-list-item> -->
                        </slot>
                        <v-list-item >
                            <v-list-item-title>Sortable List Menu</v-list-item-title>
                        </v-list-item>
                    </v-list>
                        
                </v-menu>
                
            </div>
        </div>
    </div>
    </draggable>
</template>

<script>

import ObjectViewer from '@/ui-elements/ObjectViewer'
import draggable from 'vuedraggable'
import OrderHelpers from '../helpers/OrderHelpers'
import ListHelpers from '../system/ListHelpers'
import Firestore from '@/data/Firestore'



export default {
    data() {
        return {
        
        }
    },

    components: {
        ObjectViewer,
        draggable,
    },
    
    props: {
        items: Array,
        itemWidth: {
            type: String,
            default: '100%'
        }
    },

    computed: {
        selectedItems() {
            return this.items.filter(o => o._selected)
        },
        itemStyle() {
            return `width:${this.itemWidth}`
        }
    },

    methods: {
        afterDrag(e) {
            let newOrder = OrderHelpers.getAverageOrder(e)
            let id = e.item.dataset.id
            const movedItem = this.items.find(o => o._id == id)
            const changes = {
                order: newOrder, 
                _id:id, 
                _path:movedItem._path, 
                _collection:movedItem._collection, 
                _team:movedItem._team
            }
            Firestore.saveItem(changes)
        },

        selectSingle(element) {
            console.log('SortableList > selectSingle')
            ListHelpers.selectSingle(element, this.items)
        },
        selectMulti(item) {
            console.log('SortableList > selectMulti')

            ListHelpers.selectMulti(item)    
        },

        selectRange(item) {
            console.log('SortableList > selectRange')

            ListHelpers.selectRange(item, this.items)

            //stop document from selecting text per default
            document.getSelection().removeAllRanges()
        },
        unselectAll() {
            console.log('SortableList > deselectAll')

            ListHelpers.unselectAll(this.items)
        },
    }
}
</script>

<style scoped>
    .draggable-container {
        /* border: dotted 2px #ccc!important; */
    }
    .draggable-item {
        background-color:transparent;
        transition: all 0.3s ease-in-out;
        border: dotted 1px transparent;
        border-radius: 4px;
        margin-bottom:1px;
        margin-top:1px;
        /* margin:1px; */
    }
    .draggable-item:hover {
        background-color: #f5f5f5;
        border: dotted 1px #ccc;
    }
    .draggable-handle {
        opacity: 0;
        color: black;
        transition: opacity 1.5s ease-in-out;
    }
    .draggable-item:hover .draggable-handle {
        opacity: .5;

    }

    .selected {
        border:solid 1px #58ACFA;
        background-color: rgba(174, 214, 241, 0.3)
    }
    .selected:hover {
        border:solid 1px rgb(60, 157, 248);
        background-color: rgba(174, 214, 241, 0.5)
    }
</style>




// WEBPACK FOOTER //
// SortableList.vue?6464e0ba